import { render, staticRenderFns } from "./AddTournament.vue?vue&type=template&id=26cebbe0&scoped=true"
import script from "./AddTournament.vue?vue&type=script&lang=js"
export * from "./AddTournament.vue?vue&type=script&lang=js"
import style0 from "./AddTournament.vue?vue&type=style&index=0&id=26cebbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cebbe0",
  null
  
)

export default component.exports